import React from "react";

import "./App.css";
import Root from "./routes";

function App() {
  return (
    <div className="App">
      <Root />
    </div>
  );
}

export default App;
